import type {Page, Result, ValidationError} from 'framework';
import type {
  CreateNutritionPlanInput,
  ListNutritionPlansInput,
  UpdateNutritionPlanInput,
} from '../application/ports/nutrition-plan.repository';
import type {CreateNutritionPlan} from '../application/use-cases/create-nutrition-plan';
import type {DeleteNutritionPlan} from '../application/use-cases/delete-nutrition-plan';
import type {ListNutritionPlans} from '../application/use-cases/list-nutrition-plans';
import type {UpdateNutritionPlan} from '../application/use-cases/update-nutrition-plan';
import type {NutritionPlan} from '../domain/nutrition-plan';
import type {NutritionPlanId} from '../domain/nutrition-plan-id.value-object';
import type {NutritionPlanError} from '../domain/errors';

export class NutritionPlanController {
  constructor(
    private readonly listNutritionPlans: ListNutritionPlans,
    private readonly createNutritionPlan: CreateNutritionPlan,
    private readonly updateNutritionPlan: UpdateNutritionPlan,
    private readonly deleteNutritionPlan: DeleteNutritionPlan,
  ) {}

  list(input: ListNutritionPlansInput): Promise<Result<Page<NutritionPlan>, NutritionPlanError>> {
    return this.listNutritionPlans.execute(input);
  }

  create(
    input: CreateNutritionPlanInput,
  ): Promise<Result<NutritionPlan, NutritionPlanError | ValidationError>> {
    return this.createNutritionPlan.execute(input);
  }

  update(
    input: UpdateNutritionPlanInput,
  ): Promise<Result<NutritionPlan, NutritionPlanError | ValidationError>> {
    return this.updateNutritionPlan.execute(input);
  }

  delete(planId: NutritionPlanId): Promise<Result<void, NutritionPlanError>> {
    return this.deleteNutritionPlan.execute({planId});
  }
}
